<form [formGroup]="inputForm">
  <h1 mat-dialog-title>{{title}}</h1>
  <p [innerHTML]="message | safeHTML"></p>
  <mat-input-container>
    <input matInput [type]="aspassword === true ? 'password' : 'text'" name="userinput" formControlName="userinput" required />
    <mat-hint *ngIf="inputhint && (inputForm.get('userinput').valid || !inputForm.get('userinput').value)">{{inputhint}}</mat-hint>
    <mat-hint *ngIf="inputhint && !inputForm.get('userinput').valid && inputForm.get('userinput').value && inputForm.get('userinput')?.hasError('matchingEmail')" 
        class="hinterror">Cannot use email</mat-hint>
    <mat-hint *ngIf="inputhint && !inputForm.get('userinput').valid && inputForm.get('userinput').value && inputForm.get('userinput')?.hasError('PSCInvalidID')" 
        class="hinterror">PSC Student ID is 9 alpha-numeric characters (i.e. A00143366)</mat-hint>
    <mat-hint *ngIf="inputhint && !inputForm.get('userinput').valid && inputForm.get('userinput').value && inputForm.get('userinput')?.hasError('SEUInvalidID')" 
        class="hinterror">SEU Student ID is 7 digits (i.e. 1234567)</mat-hint>
  </mat-input-container>
  <div mat-dialog-actions>
    <button mat-raised-button type="submit" color="primary" (click)="OKHandler()" [disabled]="!inputForm.valid">{{oktext}}</button>
    <button mat-raised-button type="button" color="warn" (click)="CancelHandler()">{{canceltext}}</button>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/services/dialogs/updatecollegeID/updatecollegeID.dialogcomponent.html